import React, { useEffect, useState } from "react";
import { getCallLogById } from "../../api/callLogsApi";
import { GlobalModal } from "../../../../global/GlobalModal";
import { GlobalButton } from "../../../../global/forms/GlobalFormFields";

const ViewCallLogModal = ({ callLogId, onClose }) => {
  console.log("[ViewCallLogModal] Render - callLogId:", callLogId);
  const [callLog, setCallLog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("[ViewCallLogModal] useEffect triggered, callLogId:", callLogId);
    const fetchCallLog = async () => {
      try {
        const responseData = await getCallLogById(callLogId);
        console.log("[ViewCallLogModal] Fetched data:", responseData);
        let logData = responseData?.data || responseData;
        if (Array.isArray(logData)) logData = logData[0];
        console.log("[ViewCallLogModal] Processed logData:", logData);
        setCallLog(logData);
      } catch (err) {
        console.error("[ViewCallLogModal] Fetch error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (callLogId) fetchCallLog();
  }, [callLogId]);

  const InfoRow = ({ label, value }) => (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "0.5rem 0", borderBottom: "1px solid #f1f5f9" }}>
      <span style={{ fontWeight: 600, color: "#64748b", fontSize: "0.875rem" }}>{label}</span>
      <span style={{ fontWeight: 500, color: "#1e293b", fontSize: "0.875rem", textAlign: "right" }}>{value || "—"}</span>
    </div>
  );

  return (
    <GlobalModal
      open={!!callLogId}
      onClose={onClose}
      title="Call Log Details"
      description={callLog?.caller_name ? `Viewing record for ${callLog.caller_name}` : "View call log information"}
      size="md"
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
          <GlobalButton variant="ghost" onClick={onClose}>
            Close
          </GlobalButton>
        </div>
      }
    >
      {loading ? (
        <div style={{ padding: "2rem", textAlign: "center", color: "#64748b" }}>Loading call log details...</div>
      ) : error ? (
        <div style={{ padding: "1rem", color: "var(--danger, #dc2626)" }}>{error}</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <div>
            <h3 style={{ fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--accent, #0ea5e9)", marginBottom: "0.5rem" }}>
              Call Information
            </h3>
            <InfoRow label="Call Date" value={callLog.call_date ? new Date(callLog.call_date).toLocaleDateString() : ""} />
            <InfoRow label="Call Time" value={callLog.call_time} />
            <InfoRow label="Caller Name" value={callLog.caller_name} />
            <InfoRow label="Contact Number" value={callLog.contact_number} />
            <InfoRow
              label="Call Type"
              value={
                callLog.call_type === true || callLog.call_type === 1 || String(callLog.call_type) === "1"
                  ? "Incoming"
                  : "Outgoing"
              }
            />
            <InfoRow label="Purpose" value={callLog.purpose_name || callLog.purpose_id} />
          </div>

          <div>
            <h3 style={{ fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--accent, #0ea5e9)", marginBottom: "0.5rem" }}>
              Handling & Status
            </h3>
            <InfoRow
              label="Status"
              value={
                callLog.status_name ||
                (Number(callLog.is_call_completed) === 1
                  ? "Completed"
                  : Number(callLog.is_call_completed) === 0
                    ? "Needs follow-up"
                    : undefined)
              }
            />
            <InfoRow label="Handled By" value={callLog.handled_by_name || callLog.handled_by} />
            <InfoRow label="Call Duration" value={callLog.call_duration ? `${callLog.call_duration} min` : ""} />
            <InfoRow label="Action Taken" value={callLog.action_taken} />
          </div>

          <div>
            <h3 style={{ fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--accent, #0ea5e9)", marginBottom: "0.5rem" }}>
              Follow-up & Remarks
            </h3>
            <InfoRow label="Follow-up Date" value={callLog.follow_up_date ? new Date(callLog.follow_up_date).toLocaleDateString() : "None"} />
            <InfoRow label="Remarks" value={callLog.remarks} />
          </div>
        </div>
      )}
    </GlobalModal>
  );
};

export default ViewCallLogModal;
